import React, { useState } from "react";
import { C, IMGS, SERVICES } from "../constants";
import { Reveal, Eyebrow, H, P, Btn, Chip, Sec } from "../components/UI";

function SvcImage({ svc }) {
  const [hov, setHov] = useState(false);
  return (
    <Reveal from="right">
      <div onMouseEnter={() => setHov(true)} onMouseLeave={() => setHov(false)} style={{ position: "relative", overflow: "hidden", minHeight: 520 }}>
        <div style={{ position: "absolute", inset: 0, backgroundImage: `url(${svc.image})`, backgroundSize: "cover", backgroundPosition: "center", transform: hov ? "scale(1.06)" : "scale(1)", transition: "transform 0.75s cubic-bezier(.4,0,.2,1)" }} />
        <div style={{ position: "absolute", inset: 0, background: "rgba(10,10,10,0.28)" }} />
        <div style={{ position: "absolute", top: 22, left: 22 }}><Chip>{svc.title}</Chip></div>
        <div style={{ position: "absolute", bottom: 20, right: 20, fontFamily: "'Montserrat', sans-serif", fontWeight: 900, fontSize: 100, color: "rgba(255,255,255,0.07)", lineHeight: 1, letterSpacing: -4 }}>{svc.no}</div>
      </div>
    </Reveal>
  );
}

function AddonCard({ title, desc }) {
  const [hov, setHov] = useState(false);
  return (
    <div
      onMouseEnter={() => setHov(true)} onMouseLeave={() => setHov(false)}
      style={{ background: hov ? C.accent : C.white, border: `1px solid ${hov ? C.accent : C.border}`, borderTop: `3px solid ${hov ? C.accentDark : C.accent}`, padding: "36px 28px", transition: "all 0.3s ease", cursor: "default" }}
    >
      <h3 style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 800, fontSize: 18, color: hov ? C.white : C.black, marginBottom: 12 }}>{title}</h3>
      <P size="sm" color={hov ? "rgba(255,255,255,0.78)" : C.gray}>{desc}</P>
    </div>
  );
}

export default function ServicesPage({ setPage }) {
  return (
    <div style={{ paddingTop: 84 }}>
      {/* Hero */}
      <section style={{ position: "relative", overflow: "hidden", minHeight: 460, display: "flex", alignItems: "flex-end", background: C.black }}>
        <div style={{ position: "absolute", inset: 0, backgroundImage: `url(${IMGS.studio})`, backgroundSize: "cover", backgroundPosition: "center", opacity: 0.42 }} />
        <div style={{ position: "absolute", inset: 0, background: "linear-gradient(to top, rgba(10,10,10,1) 22%, rgba(10,10,10,0.38))" }} />
        <div style={{ position: "relative", padding: "0 clamp(20px,7vw,120px) 80px", width: "100%" }}>
          <Reveal>
            <Eyebrow text="What We Offer" />
            <H size="xl" color={C.white} style={{ marginTop: 12 }}>Services Built<br />to Scale Your Brand</H>
          </Reveal>
        </div>
      </section>

      {/* Core Services */}
      {SERVICES.map((s, i) => (
        <div key={s.id} style={{ marginBottom: 3 }}>
          <div className="tp-split">
            {i % 2 !== 0 && <SvcImage svc={s} />}
            <Reveal from={i % 2 === 0 ? "left" : "right"}>
              <div style={{ background: C.white, padding: "80px clamp(28px,5.5vw,76px)", display: "flex", flexDirection: "column", justifyContent: "center", minHeight: 520 }}>
                <div style={{ display: "flex", alignItems: "center", gap: 14, marginBottom: 16 }}>
                  <span style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 900, fontSize: 12, color: "rgba(0,0,0,0.1)", letterSpacing: 1 }}>{s.no}</span>
                  <span style={{ width: 28, height: 2, background: C.accent }} />
                  <span style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 700, fontSize: 10, letterSpacing: 4, color: C.accent, textTransform: "uppercase" }}>Service</span>
                </div>
                <H size="lg" style={{ marginBottom: 12 }}>{s.title}</H>
                <P size="md" color={C.accent} style={{ marginBottom: 22, fontStyle: "italic", fontWeight: 500 }}>{s.tagline}</P>
                <P size="md" style={{ marginBottom: 32 }}>{s.description}</P>
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10, marginBottom: 36 }}>
                  {s.features.map((f) => (
                    <div key={f} style={{ display: "flex", alignItems: "center", gap: 10 }}>
                      <span style={{ width: 6, height: 6, background: C.accent, borderRadius: "50%", flexShrink: 0 }} />
                      <P size="sm" color={C.charcoal}>{f}</P>
                    </div>
                  ))}
                </div>
                <Btn variant="solid" onClick={() => { setPage("contact"); window.scrollTo(0, 0); }}>Get a Quote</Btn>
              </div>
            </Reveal>
            {i % 2 === 0 && <SvcImage svc={s} />}
          </div>
        </div>
      ))}

      {/* Supporting Services */}
      <Sec bg={C.surface}>
        <Reveal>
          <Eyebrow text="Also Available" />
          <H size="lg" style={{ marginBottom: 52 }}>Supporting Services</H>
        </Reveal>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(230px, 1fr))", gap: 3 }}>
          {[
            { title: "Branding Consultation", desc: "Brand identity, positioning, naming, and visual language for new and growing brands." },
            { title: "Copywriting",           desc: "Ad scripts, website copy, social captions, and long-form content that converts." },
            { title: "Food & Product Shoots", desc: "Mouthwatering visuals for restaurants, cloud kitchens, and e-commerce brands across India." },
            { title: "Fashion Films",         desc: "High-definition lookbooks and campaign videos for clothing and lifestyle brands." },
          ].map((a, i) => (
            <Reveal key={a.title} delay={i * 90}><AddonCard {...a} /></Reveal>
          ))}
        </div>
      </Sec>

      {/* Why Us */}
      <section style={{ background: C.black, padding: "100px clamp(20px,7vw,120px)" }}>
        <div className="tp-split" style={{ gap: 80, alignItems: "center" }}>
          <Reveal from="left">
            <Eyebrow text="Why Tharagai" />
            <H size="lg" color={C.white} style={{ marginTop: 12, marginBottom: 32 }}>Why Brands Choose<br />Us Over Others</H>
            <div style={{ display: "flex", flexDirection: "column", gap: 24 }}>
              {[
                { title: "Story-First Approach",         desc: "We start with narrative, not aesthetics. The story drives every creative decision." },
                { title: "Chennai to Pan-India",          desc: "Based in Chennai, we serve brands across Tamil Nadu, Bangalore, Mumbai, and Hyderabad." },
                { title: "Full-Service Under One Roof",   desc: "Script to screen, reel to report — everything handled in-house for quality and speed." },
                { title: "Results, Not Just Reels",       desc: "We track performance, optimise content, and deliver work that moves the needle commercially." },
              ].map((w, i) => (
                <Reveal key={w.title} delay={i * 80}>
                  <div style={{ display: "flex", gap: 20 }}>
                    <span style={{ width: 32, height: 32, background: C.accent, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, fontFamily: "'Montserrat', sans-serif", fontWeight: 900, fontSize: 12, color: C.white }}>
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    <div>
                      <h4 style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 700, fontSize: 16, color: C.white, marginBottom: 6 }}>{w.title}</h4>
                      <P size="sm" color="rgba(255,255,255,0.45)">{w.desc}</P>
                    </div>
                  </div>
                </Reveal>
              ))}
            </div>
          </Reveal>
          <Reveal from="right">
            <div style={{ position: "relative" }}>
              <div style={{ aspectRatio: "4/5", backgroundImage: `url(${IMGS.editing})`, backgroundSize: "cover", backgroundPosition: "center" }} />
              <div style={{ position: "absolute", bottom: -24, left: -20, background: C.accent, color: C.white, padding: "22px 24px" }}>
                <div style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 900, fontSize: 34, lineHeight: 1 }}>200+</div>
                <div style={{ fontFamily: "'Poppins', sans-serif", fontSize: 11, color: "rgba(255,255,255,0.7)", letterSpacing: 2, marginTop: 5 }}>PROJECTS DONE</div>
              </div>
            </div>
          </Reveal>
        </div>
      </section>

      {/* CTA */}
      <Sec bg={C.surface} style={{ textAlign: "center" }}>
        <Reveal>
          <H size="xl" style={{ marginBottom: 18 }}>Not Sure Where to Start?</H>
          <P size="lg" color={C.muted} style={{ maxWidth: 480, margin: "0 auto 36px" }}>
            Let's talk. We'll understand your brand and recommend exactly what will move the needle.
          </P>
          <Btn variant="solid" onClick={() => { setPage("contact"); window.scrollTo(0, 0); }}>
            Schedule a Free Consultation
          </Btn>
        </Reveal>
      </Sec>
    </div>
  );
}
